import { computed, ref } from 'vue';
import { uploadResourcesFor } from '../api/memberResources';

// There is no draft state on the server: the upload is itself the persistence,
// so anything a Save still governs has to be held here rather than sent early.
export function useStagedMemberResources() {
  const pending = ref([]);

  const hasPending = computed(() => pending.value.length > 0);

  // Split per file so a row the organizer sees is a thing they can take back on
  // its own, and a failed upload strands only its own file.
  const stage = ({ files, access }) => {
    files.forEach(file => pending.value.push({ files: [file], access }));
  };

  const unstage = (index) => pending.value.splice(index, 1);

  const reset = () => { pending.value = []; };

  // An entry leaves the queue only once it is actually uploaded, so a failure
  // part-way through leaves exactly the un-uploaded remainder behind and a
  // retry cannot upload the same file twice.
  const commit = async () => {
    const mediaIds = [];

    while (pending.value.length) {
      mediaIds.push(...await uploadResourcesFor(pending.value[0]));
      pending.value.shift();
    }

    return mediaIds;
  };

  return { pending, hasPending, stage, unstage, reset, commit };
}
